export default [
	{value: 'fd8', name: 'amber'},
	{value: 'aea', name: 'green'},
	{value: 'acf', name: 'blue'},
	{value: 'eae', name: 'purple'},
	{value: 'f9a', name: 'red'},
	{value: '444', name: 'black'},
	{value: 'bbb', name: 'gray'},
	{value: 'fff', name: 'white'},
];
